export class EmitMonitorList{
    isClient:boolean=false;
    clientId:string=null;
    employeeId:string=null;
    isView:boolean=false;
    isAdddedClientMonitor:boolean=false;
    isAdddedEmployeeMonitor:boolean=false;
  }

//   export class MonitorListBo {
//     id: string="00000000-0000-0000-0000-000000000000";
//     monitorId:string='00000000-0000-0000-0000-000000000000';
//     clientId: string
//     notes: string;
//     employeeId:string;
//     statusLid:string;
    
//   }
  export class GetMonitor{
    orderColumn: string = "monitorName";
    orderType: string = "asc";
    pageitem: number = 10;
    currentpageno: number = 1;
    agencyId: number;
    field: string = "monitorName";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "contains";
    type: string = "string";
    employeeId:string=null;
    StatusLid:string=null;
    clientId:string=null;
  }

  export class MonitorListBo {
    id: string="00000000-0000-0000-0000-000000000000";
    clientMonitorId: string="00000000-0000-0000-0000-000000000000"
    monitorId: string ="00000000-0000-0000-0000-000000000000";
    clientId: string;
    monitorName: string;
    notes: string;
    statusLid: string | null;
    monitorDate: string;
    statusName: string;
    inActiveDate:string | null;
}